module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', {
    staticClass: "d-table-tr",
    class: {
      'd-table-tr--odd': _vm.index % 2 === 1
    }
  }, [_c('td', {
    on: {
      "click": function($event) {
        return _vm.toggleSubject(_vm.subject)
      }
    }
  }, [_c('div', {
    staticClass: "d-checkbox",
    class: {
      'd-checkbox--active': _vm.isSelected
    }
  })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.subject.subject.name))]), _vm._v(" "), (!_vm.isSupplements) ? _c('td', [(_vm.subject.calendar) ? [_vm._v("\n      " + _vm._s(_vm.subject.calendar.name) + "\n    ")] : _vm._e()], 2) : _vm._e(), _vm._v(" "), _c('td', [(_vm.subject.subject.calendar) ? [_vm._v("\n      " + _vm._s(_vm.subject.subject.calendar.name) + "\n    ")] : _vm._e()], 2), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.subject.v_type))]), _vm._v(" "), (_vm.isSupplements) ? _c('td', [(_vm.subject.calendar) ? [_vm._v("\n      " + _vm._s(_vm.subject.calendar.name) + "\n    ")] : _vm._e()], 2) : _vm._e(), _vm._v(" "), (!_vm.isSupplements) ? _c('td', [_vm._v(_vm._s(_vm.subject.v_DefaultCategory && _vm.subject.v_DefaultCategory.name))]) : _vm._e(), _vm._v(" "), _c('td', {
    directives: [{
      name: "tippy",
      rawName: "v-tippy",
      value: ({
        placement: 'left',
        arrow: false,
        animateFill: false,
        animation: 'shift-away',
        zIndex: '999999992',
        boundary: 'window',
        onShow: function () { return _vm.selectedSubjects.length > 0; }
      }),
      expression: "{\n          placement: 'left',\n              arrow: false,\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window',\n              onShow: () => selectedSubjects.length > 0\n          }"
    }],
    attrs: {
      "content": 'Tildel til flere i stedet'
    }
  }, [(!_vm.isSupplements && _vm.taskCategories.length > 0) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.subject.selected_task_category_id),
      expression: "subject.selected_task_category_id"
    }],
    staticClass: "do-select",
    class: {
      'do-select--disabled': _vm.selectedSubjects.length > 0
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.subject, "selected_task_category_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.updateSubjectTaskCategory(_vm.subject, $event.target.value)
      }]
    }
  }, _vm._l((_vm.taskCategories), function(taskCategory, key) {
    return _c('option', {
      key: taskCategory.id,
      domProps: {
        "value": taskCategory.id
      }
    }, [_vm._v("\n        " + _vm._s(taskCategory.name) + "\n      ")])
  }), 0) : _vm._e(), _vm._v(" "), (_vm.isSupplements && _vm.salaryCodes.length > 0) ? _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.subject.salary_code_id),
      expression: "subject.salary_code_id"
    }],
    staticClass: "do-select width-100",
    class: {
      'do-select--disabled': _vm.selectedSubjects.length > 0
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.subject, "salary_code_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.updateSubjectTaskCategory(_vm.subject, $event.target.value)
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.salaryCodes), function(salaryCode, key) {
    return _c('option', {
      key: salaryCode.id,
      domProps: {
        "value": salaryCode.id
      }
    }, [_vm._v("\n        " + _vm._s(salaryCode.vSupplementTitle) + "\n      ")])
  })], 2) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-377012df!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/TaskOverviewSettings/TaskOverviewSettingsCategoriesTasksTask.vue
// module id = 1859
// module chunks = 1